/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Col_Next_StepInputs */

const cs_col_next_step = /** @type {(inputs: Col_Next_StepInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Další krok`)
};

const en_col_next_step = /** @type {(inputs: Col_Next_StepInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Next Step`)
};

/**
* | output |
* | --- |
* | "Next Step" |
*
* @param {Col_Next_StepInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const col_next_step = /** @type {((inputs?: Col_Next_StepInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Col_Next_StepInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_col_next_step(inputs)
	return cs_col_next_step(inputs)
});